/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { FunctionalComponent, h } from 'preact';
import { Router } from 'preact-router';
import "./style.css";
import Home from '../routes/home';
import Thecharts from '../routes/thecharts';
import ExchangRecords from '../routes/exchangrecords';
import Store from "../store";
import 'lib-flexible';
import 'antd-mobile/es/global'
import { useEffect } from 'preact/hooks';
import "babel-polyfill"
// import VConsole from 'vconsole';
// new VConsole();
const App: FunctionalComponent = () => {
    const initLogin = () => {
        const search = new URLSearchParams(window.location.search);
        if (search.has("access-token")) {
            localStorage.setItem("access-token", search.get("access-token") as string);
            search.delete("access-token");
            window.history.replaceState(null, "", `?${search}`);
        }
        Store.setLogin();
        Store.getUseInfo();
        Store.getConifg();
        if (search.has("bind")) {
            const bindstr = search.get("bind") || '';
            Store.bindWeibo(bindstr);
        }
    }
    useEffect(() => {
        initLogin();
    }, []);
    return (
        <div id="preact_root">
            <div id="container" />
            <Router>
                <Home path="/" store={Store} />
                <Thecharts path="/thecharts" store={Store} />
                <ExchangRecords path="/exchangrecords" store={Store} />
            </Router>
        </div>
    );
};

export default App;
